import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable } from "rxjs";
import { NUTRIENT_COMPOSITION } from "../consts/nutrient-composition";

@Injectable({
  providedIn: "root",
})
export class DietarySupplementService {
  constructor(private http: HttpClient) {}

  load(
    productFilter: any,
    general = NUTRIENT_COMPOSITION.PARTIAL,
  ): Observable<any> {
    const { page, ...filter } = productFilter;

    return this.http.get<any>(
      `${environment.primaryApiUrl}/dietary_supplement`,
      {
        params: {
          page,
          filter: JSON.stringify(filter),
          general,
          per_page: 50,
        },
      },
    );
  }

  loadCategories() {
    return this.http.get<any>(
      `${environment.primaryApiUrl}/dict/dietary_supplement_category`,
    );
  }

  collectRecipes(checkedProductsIds: number[]): Observable<any> {
    return this.http.post<any>(
      `${environment.primaryApiUrl}/recipes/selection`,
      {
        product_ids: checkedProductsIds,
      },
    );
  }

  compareProducts(checkedProductsIds: number[]): Observable<any> {
    return this.http.post<any>(
      `${environment.primaryApiUrl}/dietary_supplement/comparison`,
      {
        data: {
          ids: checkedProductsIds,
        },
      },
    );
  }

  toggleProductToLocked(productsId: number): Observable<any> {
    return this.http.put<any>(
      `${environment.primaryApiUrl}/dietary_supplement/${productsId}/locked`,
      {},
    );
  }

  loadProductGroups(): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/category`);
  }
}
